export type Routes = 'PROJECT_DASHBOARD' | 'CONTRIBUTOR' | 'COMMUNITY';

export enum RoutesEnum {
    PROJECT_DASHBOARD = '/projects',
    CLIENT_DASHBOARD = '/overview',
    CHAT = '/chat',
    LOGIN = '/login',
    CONTRIBUTOR = '/contributor',
    COMMUNITY = '/community',
    SignIn = '/signin',
    QUEST_DETAIL = '/quest/:id',
    QUEST_REVIEW = '/quest/review/:id',
    ATTACHMENT = '/attachment/:attachmentId',
    Profile = '/profile',
    TECH_LEAD = '/tech-lead',
    CONTRIBUTOR_PROFILE = '/contributor-profile',
    TASKS = '/tasks',
    TASK_DETAIL = '/task/:id',
    BUGS = '/bugs',
    QUEST_SOLUTION = '/quest-solution',
    EDIT_ACCOUNT = '/edit-account',
    REGISTER = '/register',
    CHANGE_PASSWORD = '/reset/change',
    ONBOARDING = '/onboarding',
    GITHUB_CALLBACK = '/callback/github',
    SERVICE_RESPONSE = '/service-response',
    BILLING = '/billing',
    PLAN_QUEST = '/plan/quest',
    PLAN_QUEST_SESSION = '/plan/quest/:sessionId',
    QUEST_LLM_INFO = '/quest/:id/llm-info',
    TASK_LLM_INFO = '/task/:id/llm-info',
    PROJECT_LLM_INFO = '/project/:id/llm-info'
}
